import LegalPage from "./LegalPage";

export default function TermsConditions() {
  return (
    <LegalPage
      title="Terms & Conditions"
      subtitle="Please read these terms before using ShipLess AI."
      sections={[
        {
          heading: "Use of Service",
          text: "ShipLess AI provides image optimization services for Meesho sellers. You agree to use the platform only for legal and genuine business purposes.",
        },
        {
          heading: "Credits",
          text: "Credits are used for image optimization. 1 Credit = ₹1. One optimization may cost 10 credits or as shown on the platform.",
        },
        {
          heading: "Results",
          text: "Shipping reduction may vary depending on product category, image type, and marketplace rules. We do not guarantee fixed savings for every image.",
        },
        {
          heading: "Account Responsibility",
          text: "You are responsible for keeping your account login details safe.",
        },
        {
          heading: "Changes",
          text: "We may update pricing, credits, features, or terms from time to time.",
        },
      ]}
    />
  );
}